<app-header
    [clicked]="clickedOutside"
    [langSel]="languageSelected"
    (changeMegaMenuCondition)="changeMenuCondition($event)"
    (selectedLanguage)="switchLanguageHandler($event)"
></app-header>

<div class="sm:tw-flex sm:tw-flex-col lg:tw-flex tw-bg-[#FFFCF9] lg:tw-flex-row tw-p-[3rem] lg:tw-p-20 sm:tw-p-[3rem]">
    <div class="tw-flex-col lg:tw-w-[30%] sm:tw-w-full">
        <div class="tw-font-semibold tw-text-[24x] sm:tw-sticky">{{ 'BRANCH_LOCATOR' | translate }}</div>
        <div class="sm:tw-sticky tw-mt-[30px] tw-mr-[20px] tw-py-3 tw-flex tw-w-full sm:tw-w-full lg:tw-w-[90%] tw-items-center tw-bg-white tw-rounded-3xl tw-px-[1rem] lg:tw-px-4 tw-shadow-2xl">
            <img src="/assets/images/icons/search.png" alt="Search" />
            <input
                class="tw-placeholder-gray-300 tw-font-semibold tw-text-[16px] tw-ml-2.5 tw-w-auto lg:tw-w-[640px]"
                placeholder="{{
                    'POSTAL_CODE_STATE' | translate
                }}"
                id="search"
                #searchInput
                autocomplete="off"
                (keyup)="findLocationBySearch($event)"
                (keydown)="preventEnter($event)"
                style="width: 100%;"
            />
        </div>
        <div class="tw-flex tw-mt-[20px] tw-mb-[30px] tw-cursor-pointer tw-justify-center sm:tw-justify-center lg:tw-justify-start" (click)="findOnMap(null)">
            <img src="/assets/images/icons/assistant_navigation.png" class="sm:tw-w-[6%] lg:tw-w-[5%]" alt="Assistant navigation"/>
            <span class="tw-ml-[10px] tw-text-[#8D8D8D] tw-text-[16px]">{{ 'USE_CURRENT_LOCATION' | translate }}</span>
        </div>
        <div class="tw-overflow-y-auto tw-h-[335px]">
            <div class="tw-mt-[25px]" *ngFor="let list of branchLists; index as i">
                <div class="tw-divide-y tw-divide-solid tw-text-[21px] tw-font-medium tw-mb-[20px]">{{ list.state }}</div>
                <hr class="tw-mb-[10px] sm:tw-w-[100%] lg:tw-w-[90%]">
                <div
                    class="sm:tw-w-[100%] lg:tw-w-[90%] tw-mt-[20px] tw-rounded-[25px] tw-overflow-hidden tw-bg-white tw-border-solid tw-border-[#8D8D8D] tw-border-[1px]"
                    *ngFor="let detail of list.data"
                >
                <div class="tw-px-6 tw-py-4 tw-justify-between tw-flex tw-flex-row tw-items-center">
                    <div class="tw-font-semibold tw-mb-1 tw-w-[100%]">
                        <span class="tw-text-[18px]"> {{ detail.city }} </span>
                        <span class="tw-mt-[5px] tw-text-[16px] tw-flex tw-items-center">{{ detail?.distanceText }}</span>
                    </div>
                    <div class="tw-flex tw-justify-end tw-font-semibold tw-mb-1 tw-w-[100%]">
                        <button class="btn chip-bg-branch" (click)="findDirection(detail)">{{ 'DIRECTION' | translate }}</button>
                    </div>
                    </div>
                    <hr>
                    <div class="tw-px-6 tw-pt-4 tw-pb-2 tw-border-t-[#8d8d8d]">
                        <div class="tw-font-medium tw-text-[12px] tw-text-[#8D8D8D]">{{ 'ADDRESS' | translate }}</div>
                        <div class="tw-font-medium tw-text-[16px] tw-mt-[10px] tw-mb-[10px] tw-cursor-pointer" (click)="findOnMap(detail)">{{ detail.description }}</div>
                        <div class="tw-font-medium tw-text-[12px] tw-text-[#8D8D8D] tw-mt-[20px]">{{ 'PHONE' | translate }}</div>
                        <div class="tw-font-medium tw-text-[16px] tw-mt-[10px] tw-mb-[10px]">{{ detail.phone }}</div>
                        <div class="tw-font-medium tw-text-[12px] tw-text-[#8D8D8D] tw-mt-[20px]">{{ 'FAX' | translate }}</div>
                        <div class="tw-font-medium tw-text-[16px] tw-mt-[10px] tw-mb-[10px]">{{ detail.fax }}</div>
                        <div class="tw-font-medium tw-text-[12px] tw-text-[#8D8D8D] tw-mt-[20px]">{{ 'CONTACT' | translate }}</div>
                        <div class="tw-font-medium tw-text-[16px] tw-mt-[10px] tw-mb-[10px]">{{ detail.ptc }}</div>
                        <div class="tw-font-medium tw-text-[12px] tw-text-[#8D8D8D] tw-mt-[20px]">{{ 'EMAIL' | translate }}</div>
                        <div class="tw-font-medium tw-text-[16px] tw-mt-[10px] tw-mb-[10px]">{{ detail.email }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="tw-block sm:tw-block lg:tw-hidden sm:tw-sticky">
            <button mat-raised-button class="btn-Map" (click)="openDialog()">{{ 'MAP' | translate }}</button>
        </div>
    </div>
    <div id="divmap" #map class="tw-hidden sm:tw-hidden lg:tw-block tw-ml-[40px] tw-w-[80%] tw-h-[530px] tw-overflow-visible"></div>
</div>
<app-footer
    (click)="closeMegaMenuCondition()"
    [selectedLanguage]="languageSelected"
></app-footer>
